module.exports = __webpack_public_path__ + "static/media/auction-bid-t2.1f0ef6a1.nom";